module.exports = __webpack_public_path__ + "media/images/man-31d9e5ef585cd8a878190440d997294a.jpg";